<template>
	<div class="panel" role="region" :aria-label="title || 'panel'">
		<div v-if="title" class="panel-header">
			<div class="panel-title">{{ title }}</div>
			<div class="panel-extra">
				<slot name="title-extra"></slot>
			</div>
		</div>

		<div class="panel-content">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'Panel',
	props: {
		title: {
			type: String,
			default: '',
		},
	},
}
</script>

<style lang="scss" scoped>
.panel {
	background: #ffffff;
	border: 1px solid #ebeef5; /* 与页面样式保持一致 */
	border-radius: 6px;
	overflow: hidden;
	font-family: 'Source Han Sans CN', 'Microsoft YaHei', Arial, sans-serif;
	color: #303133;
	flex: 1;
	margin-top: var(--report-grid-gap);

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 14px;
		background: #f4f6fb;
	}

	.panel-title {
		font-size: 13px;
		font-weight: 600;
		color: #333333;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.panel-extra {
		margin-left: 12px;
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.panel-content {
		padding: var(--report-grid-gap);
		background: transparent;
	}

	/* 打印友好 */
	@media print {
		.panel {
			border: none;
			box-shadow: none;
			background: #fff;
			page-break-inside: avoid;
			page-break-after: auto;
		}
		* {
			-webkit-print-color-adjust: exact !important;
			print-color-adjust: exact !important;
		}
	}
}
</style>
